/**
 * CategoriesTab Component
 *
 * Tab container for the Categories screen in ReferenceDataPage.
 * Orchestrates category sections:
 * - Market Condition Categories
 * - Entry Model Categories
 */

import React from 'react';

import { MarketConditionCategorySection } from './MarketConditionCategorySection';
import { EntryModelCategorySection } from './EntryModelCategorySection';

export const CategoriesTab: React.FC = () => {
  return (
    <div className="flex flex-col gap-6">
      {/* Market Condition Categories Section */}
      <MarketConditionCategorySection />

      {/* Entry Model Categories Section */}
      <EntryModelCategorySection />
    </div>
  );
};
